import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';

const VehicleSelectField = ({
  value,
  onChange,
  vehicles = [],
  compact = false,
}) => {
  const { t } = useTranslation('translation');
  const { isFoodMoverLite } = useAuth();
  const disabled = Boolean(isFoodMoverLite);
  const showField = disabled || vehicles.length > 0;
  if (!showField) return null;

  const wrapperSx = compact
    ? {
        flex: 1,
        minWidth: 0,
        width: { xs: '100%', sm: 'auto' },
      }
    : {
        width: '100%',
      };

  const select = (
    <FormControl
      fullWidth
      size={compact ? 'small' : undefined}
      disabled={disabled}
    >
      <InputLabel shrink>{t('donations.vehicle')}</InputLabel>
      <Select
        size={compact ? 'small' : undefined}
        label={t('donations.vehicle')}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        sx={
          compact
            ? {
                fontSize: '13px',
                minWidth: 120,
                maxWidth: 180,
              }
            : undefined
        }
      >
        <MenuItem value="">{t('common.none')}</MenuItem>
        {vehicles.map((vehicle) => (
          <MenuItem key={vehicle.id} value={vehicle.id}>
            {vehicle.name}
            {vehicle.capacity
              ? ` (${vehicle.capacity.value} ${vehicle.capacity.unit})`
              : ''}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const content = disabled ? (
    <Tooltip title={t('donations.vehicles-full-food-mover-only')} arrow>
      <Box component="span" sx={{ display: 'block', width: '100%' }}>
        {select}
      </Box>
    </Tooltip>
  ) : (
    select
  );

  return <Box sx={wrapperSx}>{content}</Box>;
};

export default VehicleSelectField;
